import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ICreateJobInterviewData } from '../../../models/dashboard/jobs/createJobInterview.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import useHttps from '../../useHttps';

const useCreateJobInterviewTime = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const createJobPostInterviewTime = (
    data: ICreateJobInterviewData,
    applicantId: string
  ): Promise<SuccessHttpResponse<any>> => {
    const url: HttpConfig = {
      url: `jobs-service/applications/${applicantId}/interviews`,
      method: 'post',
      data,
    };

    setLoading(true);
    return new Promise((resolve, reject) => {
      request(
        url,
        (response: SuccessHttpResponse<any>) => {
          toast.success(response.message);
          setLoading(false);
          resolve(response);
        },
        setLoading,
        (err: AxiosError<ErrorHttpResponse>) => {
          setLoading(false);
          toast.error(
            err?.response?.data?.message ??
              'Something went wrong setting job interview time'
          );
          reject(err);
        }
      );
    });
  };

  return { createJobPostInterviewTime, loading };
};

export default useCreateJobInterviewTime;
